import axios from "axios";
import queryString from "query-string";
import { Modal } from "react-bootstrap";
import base_url from "../../api/bootapi";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";

const DormantCancellationForm = () => {
  const { search } = useLocation();
  const queryparam = queryString.parse(search);
  let messagesEndRef = useRef(null);

  //------------------->Boolean States
  const [message, setmessage] = useState();
  const [token, settoken] = useState("");
  const [loader, setloader] = useState(false);
  const [showimeiui, setshowimeiui] = useState(false);
  const [error, seterror] = useState(false);
  const [success, setsuccess] = useState(false);
  const [showsuccessmodal, setshowsuccessmodal] = useState(false);
  const [terminatemodal, setterminatemodal] = useState(false);

  //------------------------>Data storing states
  const [imeidevice, setimeidevice] = useState("");
  const [imeilisting, setimeilisting] = useState([]);
  const [imeidevicedetail, setimeidevicedetail] = useState({});

  const { handleSubmit } = useForm({
    mode: "all",
  });

  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    let user = localStorage.getItem("common");
    if (user) {
      user = JSON.parse(user);
      if (user && user["token"] && queryparam?.["customer_id"]) {
        settoken(user.token);
        axios
          .get(
            `${base_url}/auth/dormant-mode/activated?customer_id=${queryparam["customer_id"]}`,
            {
              headers: {
                Authorization: `JWT ${user?.token}`,
              },
            }
          )
          .then((res) => {
            if (res.data.status) {
              setimeilisting(res.data.result);
            }
          });
      }
    }
  }, []);

  const checkimeidetails = () => {
    for (let i = 0; i < imeilisting.length; i++) {
      if (imeilisting[i]["imei"] === imeidevice) {
        setimeidevicedetail(imeilisting[i]);
        setshowimeiui(true);
        break;
      }
    }
  };

  const canceldormant = () => {
    setterminatemodal(true);
  };
  const handleterminate = () => {
    setterminatemodal(false);
    setloader(true);
    let data = {
      customer_id: imeidevicedetail["customer_id"],
      imei: imeidevicedetail["imei"],
    };
    axios
      .post(`${base_url}/auth/dormant-mode/cancel`, data, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
      .then((res) => {
        setloader(false);
        if (res.data.status) {
          setsuccess(true);
          setshowsuccessmodal(true);
          seterror(false);
        } else {
          let error = res.data.message;
          if (res.data.error) error = error + " : " + res.data.error;
          setmessage(error);
          setsuccess(false);
          seterror(true);
          setloader(false);
          scrollToBottom();
        }
      })
      .catch((err) => {
        if (err.response) {
          let error = err.response.data?.message;
          if (err.response.data?.error) {
            error = error + " : " + err.response.data?.error;
          }
          setmessage(error);
        } else {
          setmessage("Something Went Wrong");
        }
        setsuccess(false);
        seterror(true);
        setloader(false);
        scrollToBottom();
      });
  };

  const handleCloseModal = () => {
    setshowsuccessmodal(false);
    setsuccess(true);
    scrollToBottom();
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <form id="myForm" onSubmit={handleSubmit(canceldormant)}>
      <div>
        <h4 className="cancellationobd_h4">Cancel Dormant Subscription</h4>
        {loader ? (
          <img width={300} alt="loader" src="./loading.gif" />
        ) : (
          <>
            {!showimeiui ? (
              <>
                <div className="form-group">
                  <div className="row text-left form-group">
                    <div className="col-md-3 reactivationobd_font">
                      Customer ID :
                    </div>
                    <div className="col-md-9 reactivationobd_font">
                      {queryparam?.customer_id}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <select
                        value={imeidevice}
                        onChange={(e) => setimeidevice(e.target.value)}
                        className="form-control"
                      >
                        <option value="">Select IMEI</option>
                        {imeilisting.map((item, index) => (
                          <option key={index + 1} value={item.imei}>
                            {item.imei}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6">
                      <button
                        disabled={!imeidevice}
                        className={
                          !imeidevice
                            ? "btn btn-primary buttondisabled reactivatebutton"
                            : "btn btn-primary reactivatebutton"
                        }
                        onClick={checkimeidetails}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="form-group">
                  <div className="row text-left form-group">
                    <div className="col-md-5 reactivationobd_font">Email :</div>
                    <div className="col-md-7 reactivationobd_font">
                      {imeidevicedetail?.email}
                    </div>
                  </div>
                  <div className="row text-left form-group">
                    <div className="col-md-5 reactivationobd_font">
                      Customer ID :
                    </div>
                    <div className="col-md-7 reactivationobd_font">
                      {imeidevicedetail?.customer_id}
                    </div>
                  </div>
                  <div className="row text-left ">
                    <div className="col-md-5 reactivationobd_font">
                      IMEI NUMBER :
                    </div>
                    <div className="col-md-7 reactivationobd_font">
                      {imeidevicedetail?.imei}
                    </div>
                  </div>
                  <div className="row text-left ">
                    <div className="col-md-5 reactivationobd_font">ICCID :</div>
                    <div className="col-md-7 reactivationobd_font">
                      {imeidevicedetail?.iccid}
                    </div>
                  </div>
                  <div className="row text-left ">
                    <div className="col-md-5 reactivationobd_font">
                      Subscription End Date :
                    </div>
                    <div className="col-md-7 reactivationobd_font">
                      {imeidevicedetail?.end_date}
                    </div>
                  </div>
                </div>
                {error ? (
                  <div>
                    <div className="alert alert-danger">
                      <strong>Error! </strong>
                      {message}
                    </div>
                  </div>
                ) : null}
                <div ref={messagesEndRef} />
                {success ? (
                  <div>
                    <div className="alert alert-success">
                      <strong>Success! </strong>
                      Dormant Subscription Cancelled Successfully
                    </div>
                  </div>
                ) : (
                  <div
                    className="activation"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div></div>
                    <button className={"btn btn-primary"} type="submit">
                      Cancel
                    </button>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
      {/* Terminate Modal */}
      <Modal
        size="md"
        show={terminatemodal}
        onHide={() => setterminatemodal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton={() => setterminatemodal(false)}>
          <Modal.Title style={{ color: "#3947e6" }}>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className="form-main" style={{ color: "#3947e6" }}>
            Are you sure you want to cancel dormant subscription ?
          </h4>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            <button
              onClick={() => setterminatemodal(false)}
              type="button"
              className="btn btn-danger mr-2"
            >
              No
            </button>
            <button
              onClick={() => handleterminate()}
              type="button"
              className="btn btn-primary"
            >
              Yes
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        size="md"
        show={showsuccessmodal}
        onHide={() => handleCloseModal()}
        backdrop="static"
      >
        <Modal.Header closeButton={() => handleCloseModal()}>
          <Modal.Title style={{ color: "#3947e6" }}>Success!!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className="form-main" style={{ color: "#3947e6" }}>
            Dormant Subscription Cancelled Successfully
          </h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => handleCloseModal()}
            type="button"
            className="btn btn-primary"
          >
            Ok
          </button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default DormantCancellationForm;
